import { createBrowserClient } from '@supabase/ssr';

/**
 * Creates a Supabase client for Client Components
 * Uses browser localStorage for session management
 * DO NOT use this in Server Components - use server.ts instead
 */
export function createClient() {
  // Use Vite environment variables for browser
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
  const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

  if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase environment variables. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.');
  }

  return createBrowserClient(supabaseUrl, supabaseKey);
}
